import { createSlice } from "@reduxjs/toolkit";
import { getContents, getAIContentApproval, getAIContentTBED } from "./thunk";

export interface IState {
  contents: any;
  isContentLoading: boolean;
  isContentSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  contents: null,
  isContentLoading: false,
  isContentSuccess: false,

  error: {},
};

const ContentSlice = createSlice({
  name: "Content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContents.pending, (state: IState, action: any) => {
      state.isContentLoading = true;
    });
    builder.addCase(getContents.fulfilled, (state: IState, action: any) => {
      state.contents = action.payload.data;
      state.isContentSuccess = true;
      state.isContentLoading = false;
    });
    builder.addCase(getContents.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isContentSuccess = false;
      state.isContentLoading = false;
    });
  },
});

const AIContentApprovalSlice = createSlice({
  name: "AIContentApproval",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAIContentApproval.pending, (state: IState, action: any) => {
      state.isContentLoading = true;
    });
    builder.addCase(getAIContentApproval.fulfilled, (state: IState, action: any) => {
      state.contents = action.payload.data;
      state.isContentSuccess = true;
      state.isContentLoading = false;
    });
    builder.addCase(getAIContentApproval.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isContentSuccess = false;
      state.isContentLoading = false;
    });
  },
});

const AIContentTBEDSlice = createSlice({
  name: "AIContentTBED",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAIContentTBED.pending, (state: IState, action: any) => {
      state.isContentLoading = true;
    });
    builder.addCase(getAIContentTBED.fulfilled, (state: IState, action: any) => {
      state.contents = action.payload.data;
      state.isContentSuccess = true;
      state.isContentLoading = false;
    });
    builder.addCase(getAIContentTBED.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isContentSuccess = false;
      state.isContentLoading = false;
    });
  },
});

export default ContentSlice.reducer;
export const AIContentApprovalReducer = AIContentApprovalSlice.reducer;
export const AIContentTBEDReducer = AIContentTBEDSlice.reducer;